import { Theme } from '@mui/material'

export const overwriteMinimalTableHeadCellStyle = {
  sx: {
    backgroundColor: 'rgb(244, 246, 248)',
    '& .Mui-TableHeadCell-Content': {
      display: 'flex',
      width: '100%',
    },
    '& .Mui-TableHeadCell-Content-Labels': {
      display: 'flex',
      width: '100%',
    },
    '& .Mui-TableHeadCell-Content-Wrapper': {
      display: 'flex',
      width: '100%',
    },
  },
}

export const overwriteMinimalTableDetailPanelStyle = {
  sx: (theme: Theme) => ({
    borderBottom: `1px solid ${theme.palette.grey[400]}`,
  }),
}

export const overwriteMinimalTableBodyCellStyle = {
  sx: (theme: Theme) => ({
    borderBottom: `1px solid ${theme.palette.grey[400]}`,
  }),
}

export const overwriteMinimalTableBodyRowStyle = (isExpanded: boolean) => ({
  sx: (theme: Theme) => ({
    backgroundColor: isExpanded ? theme.palette.grey[200] : 'current',
  }),
})
